export const formatMoney = (value) => {
    if (!value && value !== 0) return '0,00';
    return Math.abs(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const processarBalanceteContabil = (listaContas) => {
    if (!Array.isArray(listaContas)) return [];

    const mapa = {};
    const raizes = [];

    listaContas.forEach(conta => {
        mapa[conta.codigo] = {
            ...conta,
            children: [],
            vlTotalSaldoInicial: Number(conta.vlTotalSaldoInicial || conta.vl_total_saldo_inicial) || 0,
            vlTotalDebitos: Number(conta.vlTotalDebitos || conta.vl_total_debitos) || 0,
            vlTotalCreditos: Number(conta.vlTotalCreditos || conta.vl_total_creditos) || 0,
            vlTotalSaldoFinal: Number(conta.vlTotalSaldoFinal || conta.vl_total_saldo_final) || 0,
        };
    });

    Object.values(mapa).forEach(conta => {
        if (conta.codigo.includes('.')) {
            const partes = conta.codigo.split('.');
            const codigoPai = partes.slice(0, -1).join('.');

            if (mapa[codigoPai]) {
                mapa[codigoPai].children.push(conta);
            } else {
                raizes.push(conta);
            }
        } else {
            raizes.push(conta);
        }
    });


    const calcularTotaisRecursivo = (node) => {
        if (node.children.length > 0) {
            node.children.sort((a, b) =>
                a.codigo.localeCompare(b.codigo, undefined, { numeric: true, sensitivity: 'base' })
            );

            let somaSI = 0, somaDeb = 0, somaCred = 0, somaSF = 0;

            node.children.forEach(filho => {
                const totaisFilho = calcularTotaisRecursivo(filho);
                somaSI += totaisFilho.si;
                somaDeb += totaisFilho.deb;
                somaCred += totaisFilho.cred;
                somaSF += totaisFilho.sf;
            });

            node.vlTotalSaldoInicial = somaSI;
            node.vlTotalDebitos = somaDeb;
            node.vlTotalCreditos = somaCred;
            node.vlTotalSaldoFinal = somaSF;
        }

        return {
            si: node.vlTotalSaldoInicial,
            deb: node.vlTotalDebitos,
            cred: node.vlTotalCreditos,
            sf: node.vlTotalSaldoFinal
        };
    };

    raizes.forEach(raiz => calcularTotaisRecursivo(raiz));
    raizes.sort((a, b) => a.codigo.localeCompare(b.codigo, undefined, { numeric: true }));


    const checkHasValueRecursivo = (node) => {
        const temValorProprio =
            Math.abs(node.vlTotalSaldoInicial) > 0.01 ||
            Math.abs(node.vlTotalDebitos) > 0.01 ||
            Math.abs(node.vlTotalCreditos) > 0.01 ||
            Math.abs(node.vlTotalSaldoFinal) > 0.01;

        if (temValorProprio) return true;
        if (node.children && node.children.length > 0) {
            return node.children.some(filho => checkHasValueRecursivo(filho));
        }
        return false;
    };

    const flatten = (nodes, level = 0) => nodes.reduce((acc, node) => {
        const temValorOuDescendente = checkHasValueRecursivo(node);

        if (temValorOuDescendente) {
            acc.push({ ...node, level, key: node.codigo });

            if (node.children && node.children.length > 0) {
                acc = acc.concat(flatten(node.children, level + 1));
            }
        }

        return acc;
    }, []);

    return flatten(raizes);
};
